import { flow, isEqual, omitBy } from 'lodash/fp';
import {
  getFormValues,
  startSubmit as startFormSubmit,
  stopSubmit as stopFormSubmit,
} from 'redux-form';

import { getSearchUrl } from 'helpers/namedUrls';
import { STANDARD_PRICE_ASC } from 'helpers/fieldOptions/ad/sort';
import { SORT_NAME } from 'components/searchAds/constants';
import stringifyAdsQuery from 'components/searchAds/stringifyAdsQuery';
import formToQuery from 'components/searchAds/mappers/formToQuery';
import formScaffolding from 'components/searchAds/mappers/formScaffolding';
import { EXTRA_FILTERS_QUERY_KEY } from 'components/searchAds/SearchLayout/constants';
import { selectCarMakeById } from 'store/ducks/manufacturers';

export const applyFilters = (formName, { applyDefaultSort } = {}) =>
  function* ({ getState, routeHelpers }) {
    let formValues = getFormValues(formName)(getState());

    formValues = applyDefaultSort
      ? { ...formValues, [SORT_NAME]: STANDARD_PRICE_ASC }
      : formValues;

    const carMakeById = selectCarMakeById(getState());
    const query = flow(
      omitBy((value, key) => isEqual(formScaffolding[key], value)),
      formToQuery(carMakeById),
    )(formValues);
    const location = {
      pathname: getSearchUrl(),
      search: stringifyAdsQuery(query),
    };

    yield startFormSubmit(formName);
    yield routeHelpers.pushRoute(location);
    yield stopFormSubmit(formName);
  };

export const navigateToSearchWithExtraFilters = (
  formName,
  { applyDefaultSort } = {},
) =>
  function* ({ getState, routeHelpers }) {
    let formValues = getFormValues(formName)(getState());

    formValues = applyDefaultSort
      ? { ...formValues, [SORT_NAME]: STANDARD_PRICE_ASC }
      : formValues;

    const carMakeById = selectCarMakeById(getState());
    const query = flow(
      omitBy((value, key) => isEqual(formScaffolding[key], value)),
      formToQuery(carMakeById),
    )(formValues);
    const queryWithExtraFilters = { ...query, [EXTRA_FILTERS_QUERY_KEY]: 1 };
    const location = {
      pathname: getSearchUrl(),
      search: stringifyAdsQuery(queryWithExtraFilters),
    };

    yield startFormSubmit(formName);
    yield routeHelpers.pushRoute(location);
    yield stopFormSubmit(formName);
  };
